webpackJsonp([106782234767675],{

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ExamplePage = __webpack_require__(6);
	
	var _ExamplePage2 = _interopRequireDefault(_ExamplePage);
	
	var _CodeSample = __webpack_require__(5);
	
	var _CodeSample2 = _interopRequireDefault(_CodeSample);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _ExamplePage2.default,
	    { title: 'Input field' },
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/api/DayPickerInput' },
	        'DayPickerInput'
	      ),
	      ' binds the DayPicker with an input field, displaying the calendar in an overlay.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'small',
	        null,
	        'See also how to',
	        ' ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/examples/input-state' },
	          'use it with state'
	        ),
	        ', how to',
	        ' ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/examples/input-custom-overlay' },
	          'customize the overlay'
	        ),
	        ' ',
	        'and how to',
	        ' ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/examples/input-moment' },
	          'change the date format'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(_CodeSample2.default, { name: 'examples/input' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-examples-input-js-b60a1567bc837f627c7b.js